(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.__collectionFilterSortFloatingInit) {
    window.__collectionFilterSortFloatingInit = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melden-home-model-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.melden-home-model-rail').forEach(function (rail) {
    var scroller = rail.querySelector('[data-melden-rail-scroller]');
    if (!scroller) return;

    function step() {
      var tile = scroller.querySelector('.melden-model-tile');
      if (!tile) return 320;
      var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 20;
      return tile.getBoundingClientRect().width + gap;
    }

    var prev = rail.querySelector('[data-melden-rail-prev]');
    var next = rail.querySelector('[data-melden-rail-next]');
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();
})();
